import _ from 'lodash';
import React, { Fragment } from 'react';
import ReactCountryFlag from "react-country-flag";
import { Dialog, Transition } from '@headlessui/react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { ButtonCssClass, cn } from '@/services/Methods/normalMethods';
import localStorageCall from '@/services/Methods/localstorage.hook';
import countryListAllIsoData from '@/comman/AllStatesCodeArray';

const CountryFlagDropdown = ({
    countyObjects,
    showCountries,
    selectedStore,
    setSelectedStore,
    setShowCountries,
    pathname,
    countriesShow,
    setCountriesShow,
    onCountrySelect
}) => {
    const PREVIOUS_COUNTRY_NAME = _.find(countryListAllIsoData, {
        code: _.upperCase(selectedStore?.defaultCode)
    })?.name;

    const NEXT_COUNTRY_NAME = _.find(countryListAllIsoData, {
        code: _.upperCase(selectedStore?.newCode)
    })?.name;

    const allowedCountryCodes = [
        'KH', 'CO', 'CR', 'IL', 'JO', 'LA',
        'MY', 'MX', 'PS', 'PA', 'PE', 'TH',
        'AE', 'US'
    ];

    const isDistributorPage = pathname.includes('/distributor');


    return (
        <>
            <ul
                className={cn(
                    `dropdown-menu hidden dropdown-menu-right show max-lg:mt-2 bg-white flex-col gap-[10px] lg:absolute top-[40px] right-0 min-w-[180px] rounded-[4px] p-[10px] border border-[#591069] did-fade-in`,
                    (showCountries || countriesShow) && 'open-country [&.open-country]:flex',
                    isDistributorPage && 'max-h-[200px] overflow-y-auto'
                )}
                x-placement="top-end"
            >
                {_.map(
                    _.filter(countyObjects, (row) => allowedCountryCodes.includes(row?.code)),
                    (row) => (
                        <li
                            key={row?.code}
                            className="block"
                            onClick={() => {
                                if (onCountrySelect) {
                                    // Use the custom handler from parent component
                                    onCountrySelect(row?.code);
                                } else {
                                    // Fallback to original behavior
                                    setSelectedStore((prv) => ({
                                        ...prv,
                                        newCode: _.lowerCase(row?.code)
                                    }));
                                }

                                if (isDistributorPage) {
                                    if (typeof setCountriesShow === 'function') {
                                        setCountriesShow(!countriesShow);
                                    }
                                } else {
                                    if (typeof setShowCountries === 'function') {
                                        setShowCountries(!showCountries);
                                    }
                                }
                            }}
                        >
                            <button
                                className="w-full text-left flex items-center gap-2 text-sm lg:text-[16px] bg-transparent hover:bg-gray-100 focus:bg-gray-100 active:bg-gray-100 px-2 py-1 rounded transition-colors duration-200"
                            >
                                <ReactCountryFlag
                                    countryCode={row?.code}
                                    svg
                                    className="!block"
                                    style={{
                                        fontSize: '1em',
                                        marginRight: '4px',
                                        lineHeight: '2em',
                                        backgroundColor: 'transparent'
                                    }}
                                />
                                {row?.name}
                            </button>
                        </li>
                    )
                )}
            </ul>

            {/* Modal */}
            <Transition appear show={selectedStore?.defaultCode !== selectedStore?.newCode} as={Fragment}>
                <Dialog as="div" className="relative z-[1400]" onClose={() => console.log('close')}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[rgba(0,0,0,0.8)]" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center text-center px-4">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className="z-[1400] w-full max-w-[600px] transform rounded-md bg-white p-5 md:p-7 text-left align-middle transition-all"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <Dialog.Title as="h2" className="text-base font-medium text-[#591069] mb-2">
                                        Change Country
                                    </Dialog.Title>

                                    <div className="flex py-2 mb-2 font-semibold border-b-2 justify-center gap-2 items-center">
                                        <p>{PREVIOUS_COUNTRY_NAME}</p>
                                        <ArrowRightAltIcon />
                                        <p>{NEXT_COUNTRY_NAME}</p>
                                    </div>

                                    <div>
                                        <p>
                                            Are you sure you want to change country? Your cart will be emptied and you
                                            will be sent back to the{' '}
                                            {_.includes(pathname, 'distributor')
                                                ? 'Enrollment flow'
                                                : _.includes(pathname, 'products')
                                                    ? 'product page'
                                                    : 'homepage'}
                                            .
                                        </p>
                                    </div>

                                    <div className="w-full flex justify-center gap-x-3 md:gap-x-5 mt-4 flex-col sm:flex-row gap-y-3 sm:gap-y-0">
                                        <button
                                            type="button"
                                            className="site-btn !mb-0 max-w-[200px] w-full sm:w-auto !min-h-[44px] relative z-[1500] cursor-pointer touch-manipulation"
                                            style={{ touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' }}
                                            onClick={() => {
                                                setSelectedStore((prv) => ({
                                                    ...prv,
                                                    newCode: prv?.defaultCode
                                                }));
                                            }}
                                            onTouchEnd={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setSelectedStore((prv) => ({
                                                    ...prv,
                                                    newCode: prv?.defaultCode
                                                }));
                                            }}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="button"
                                            className="site-btn !mb-0 max-w-[200px] w-full sm:w-auto !min-h-[44px] relative z-[1500] cursor-pointer touch-manipulation bg-[#428bca] text-[#fff]"
                                            style={{ touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' }}
                                            onClick={() => {
                                                _.map(['normal', 'distributor'], (row) => {
                                                    localStorageCall().removeItem(`${row}Products`);
                                                    localStorageCall().setItem('store', selectedStore?.newCode);
                                                    setSelectedStore((prv) => ({
                                                        ...prv,
                                                        defaultCode: prv?.newCode
                                                    }));

                                                    if (_.includes(pathname, 'distributor')) {
                                                        localStorageCall().setItem('distributor_store', selectedStore?.newCode);

                                                    }

                                                    if (_.includes(pathname, 'main-enrollment')) {
                                                        window.location.assign(`/${selectedStore?.newCode}/main-enrollment`);
                                                    } else if (_.includes(pathname, 'products') || _.includes(pathname, 'checkout')) {
                                                        window.location.assign(`/${selectedStore?.newCode}/products`);
                                                    } else if (_.includes(pathname, 'distributor')) {
                                                        window.location.assign(`/${selectedStore?.newCode}/distributor`);
                                                    } else {
                                                        window.location.assign(`/${selectedStore?.newCode}`);
                                                    }
                                                });
                                            }}
                                            onTouchEnd={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                _.map(['normal', 'distributor'], (row) => {
                                                    localStorageCall().removeItem(`${row}Products`);
                                                    localStorageCall().setItem('store', selectedStore?.newCode);
                                                    setSelectedStore((prv) => ({
                                                        ...prv,
                                                        defaultCode: prv?.newCode
                                                    }));

                                                    if (_.includes(pathname, 'distributor')) {
                                                        localStorageCall().setItem('distributor_store', selectedStore?.newCode);

                                                    }

                                                    if (_.includes(pathname, 'main-enrollment')) {
                                                        window.location.assign(`/${selectedStore?.newCode}/main-enrollment`);
                                                    } else if (_.includes(pathname, 'products') || _.includes(pathname, 'checkout')) {
                                                        window.location.assign(`/${selectedStore?.newCode}/products`);
                                                    } else if (_.includes(pathname, 'distributor')) {
                                                        window.location.assign(`/${selectedStore?.newCode}/distributor`);
                                                    } else {
                                                        window.location.assign(`/${selectedStore?.newCode}`);
                                                    }
                                                });
                                            }}
                                        >
                                            Ok
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
};

export default CountryFlagDropdown;
